import { render, staticRenderFns } from "./ExportXCCDFResults.vue?vue&type=template&id=2ccfe988"
import script from "./ExportXCCDFResults.vue?vue&type=script&lang=ts"
export * from "./ExportXCCDFResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ccfe988')) {
      api.createRecord('2ccfe988', component.options)
    } else {
      api.reload('2ccfe988', component.options)
    }
    module.hot.accept("./ExportXCCDFResults.vue?vue&type=template&id=2ccfe988", function () {
      api.rerender('2ccfe988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/ExportXCCDFResults.vue"
export default component.exports